import { fb, validators } from "../../../form";
//import utils from '../../../utils';

export function getShippingFormData(cart) {
  const data = cart || {};

  console.log("data.pickupDate", data.pickupDate);

  const shippingMethods = [
    { name: "Delivery", value: "Standard" },
    { name: "Pickup", value: "Pickup" },
  ];

  const shippingCountry = [
    { name: "Australia", value: "Australia" },
    { name: "International", value: "International" },
  ];

  const locationList = [
    { name: "Cafe de Vili's (Mile End)", value: "Cafe de Vili's (Mile End)" },
    // { name: 'Bunnings Parafield', value: "Bunnings Parafield" },
    // { name: 'Bunnings Munno Para', value: "Bunnings Munno Para" },
    // { name: 'Bunnings Woodville', value: "Bunnings Woodville" },
    // { name: 'Bunnings Noarlunga', value: "Bunnings Noarlunga" },
    // { name: 'Bunnings Marion', value: "Bunnings Marion" },
    // { name: 'Bunnings Victor Harbor', value: "Bunnings Victor Harbor" }
  ];

  //const location = data.orderExtSerializedObj && data.orderExtSerializedObj.location ? data.orderExtSerializedObj.location : null;
  //const availableFirstDate = utils.date.formatYYYYMMDD(data.availableFirstDate);

  // const checkTodayFun = () => {
  //   if (data.deliveryPickupDate && data.deliveryPickupDate !== ''){
  //     let today = new Date(utils.date.formatYYYYMMDDToday()).getTime();
  //     let _deliveryPickupDate = new Date(data.deliveryPickupDate).getTime();
  //     if(_deliveryPickupDate === today){
  //       return true;
  //     }
  //   }
  //   return false;
  // }

  // const checkTodayFunT = () => {
  //   let time = new Date().toLocaleTimeString();
  //   let timeTokenizered = time.split(":");
  //   let hour = timeTokenizered[0];
  //   let min = timeTokenizered[1];

  //   if(parseInt(min) >= 30){
  //     hour = (parseInt(timeTokenizered[0]) + 1).toString();
  //     min = "0"
  //   }
  //   else{
  //     min = "30"
  //   }

  //   let startHour = (parseInt(hour) + 2) * 60 + (parseInt(min));
  //   let results = [{ name: 'Select Time', value: '' }];

  //   while( startHour <= 1410){

  //     let _value = (startHour / 60).toString().split(".");

  //     let _convertedHour = _value[0];
  //     let _convertedAMPM = "AM";
  //     if(_convertedHour >= 13){
  //       _convertedAMPM = "PM";
  //       _convertedHour = _convertedHour - 12;
  //     }

  //     let v = _convertedHour + ":" + (_value.length === 2 ? '30' : '00') + " " + _convertedAMPM;

  //     results.push({ name:  v, value: v });
  //     startHour = startHour + 30;

  //   }

  //   return results;
  // }

  //checkTodayFunT();

  //const availableFirstDate = utils.date.formatYYYYMMDDToday();

  //const pickupDate = data.orderExtSerializedObj && data.orderExtSerializedObj.pickupDate ? data.orderExtSerializedObj.pickupDate : null;
  //const pickupTime = data.orderExtSerializedObj && data.orderExtSerializedObj.pickupTime ? data.orderExtSerializedObj.pickupTime : null;

  let pickupTimeList = [
    "06:00 AM to 08:00 AM",
    "07:00 AM to 09:00 AM",
    "08:00 AM to 10:00 AM",
    "09:00 AM to 11:00 AM",
    "10:00 AM to 12:00 PM",
    "11:00 AM to 01:00 PM",
  ].map((x) => {
    return { name: x, value: x };
  });

  // pickupTimeList = [{name: 'Select Time', value: ''}, ...pickupTimeList];

  //pickupTimeList =  checkTodayFun() === false ? [{name: 'Select Time', value: ''}, ...pickupTimeList] : checkTodayFunT();
  pickupTimeList = [{ name: "Select Time", value: "" }, ...pickupTimeList];

  const deliveryList = [
    { name: "Select Date", value: "" },
    // Reconciliation Week (May 26 - June 3)
    { name: "Tuesday 26th May 2026", value: "Tuesday 26th May 2026", date: new Date(2026, 4, 26) },
    { name: "Wednesday 27th May 2026", value: "Wednesday 27th May 2026", date: new Date(2026, 4, 27) },
    { name: "Thursday 28th May 2026", value: "Thursday 28th May 2026", date: new Date(2026, 4, 28) },
    { name: "Friday 29th May 2026", value: "Friday 29th May 2026", date: new Date(2026, 4, 29) },
    { name: "Saturday 30th May 2026", value: "Saturday 30th May 2026", date: new Date(2026, 4, 30) },

    { name: "Monday 1st June 2026", value: "Monday 1st June 2026", date: new Date(2026, 5, 1) },
    { name: "Tuesday 2nd June 2026", value: "Tuesday 2nd June 2026", date: new Date(2026, 5, 2) },
    { name: "Wednesday 3rd June 2026", value: "Wednesday 3rd June 2026", date: new Date(2026, 5, 3) },

    // NAIDOC Week period 1 (July 1 - July 3)
    { name: "Wednesday 1st July 2026", value: "Wednesday 1st July 2026", date: new Date(2026, 6, 1) },
    { name: "Thursday 2nd July 2026", value: "Thursday 2nd July 2026", date: new Date(2026, 6, 2) },
    { name: "Friday 3rd July 2026", value: "Friday 3rd July 2026", date: new Date(2026, 6, 3) },

    // NAIDOC Week period 2 (July 6 - July 11)
    { name: "Monday 6th July 2026", value: "Monday 6th July 2026", date: new Date(2026, 6, 6) },
    { name: "Tuesday 7th July 2026", value: "Tuesday 7th July 2026", date: new Date(2026, 6, 7) },
    { name: "Wednesday 8th July 2026", value: "Wednesday 8th July 2026", date: new Date(2026, 6, 8) },
    { name: "Thursday 9th July 2026", value: "Thursday 9th July 2026", date: new Date(2026, 6, 9) },
    { name: "Friday 10th July 2026", value: "Friday 10th July 2026", date: new Date(2026, 6, 10) },
    { name: "Saturday 11th July 2026", value: "Saturday 11th July 2026", date: new Date(2026, 6, 11) },
  ];

  const convertDateToText = (date) => {
    //const _day = date.getDay();
    let _dayText = "";
    let _dateText = "";
    let _monthText = "";
    const _date = date.getDate();

    switch (date.getDay()) {
      case 0:
        _dayText = "Sunday";
        break;
      case 1:
        _dayText = "Monday";
        break;
      case 2:
        _dayText = "Tuesday";
        break;
      case 3:
        _dayText = "Wednesday";
        break;
      case 4:
        _dayText = "Thursday";
        break;
      case 5:
        _dayText = "Friday";
        break;
      case 6:
        _dayText = "Saturday";
        break;
      default:
        break;
    }

    switch (_date) {
      case 1:
        _dateText = "1st";
        break;
      case 2:
        _dateText = "2nd";
        break;
      case 3:
        _dateText = "3rd";
        break;
      case 21:
        _dateText = "21st";
        break;
      case 22:
        _dateText = "22nd";
        break;
      case 23:
        _dateText = "23rd";
        break;
      case 31:
        _dateText = "31st";
        break;
      default:
        _dateText = _date + "th";
        break;
    }

    switch (date.getMonth()) {
      case 0:
        _monthText = "January";
        break;
      case 1:
        _monthText = "February";
        break;
      case 2:
        _monthText = "March";
        break;
      case 3:
        _monthText = "April";
        break;
      case 4:
        _monthText = "May";
        break;
      case 5:
        _monthText = "June";
        break;
      case 6:
        _monthText = "July";
        break;
      case 7:
        _monthText = "August";
        break;
      case 8:
        _monthText = "September";
        break;
      case 9:
        _monthText = "October";
        break;
      case 10:
        _monthText = "November";
        break;
      case 11:
        _monthText = "December";
        break;
      default:
        break;
    }
    return (
      _dayText + " " + _dateText + " " + _monthText + " " + date.getFullYear()
    );
  };

  if (!localStorage.dumyDeliveryDate) {
    localStorage.setItem("dumyDeliveryDate", "");
  }

  const getDeliveryDate = () => {
    const dumyDeliveryDate = localStorage.getItem("dumyDeliveryDate");
    const _today = new Date();
    const currentHour = _today.getHours();
    // const currentHour = 16;
    const currentDate = new Date(_today.getFullYear(), _today.getMonth(), _today.getDate());
    // const currentDate = new Date(2025, 6, 3);

    const startDate =
      dumyDeliveryDate && dumyDeliveryDate !== ""
        ? new Date(dumyDeliveryDate)
        : new Date(
          _today.getMonth() +
          1 +
          "/" +
          _today.getDate() +
          "/" +
          _today.getFullYear()
        );

    const orignStartDate =
      dumyDeliveryDate && dumyDeliveryDate !== ""
        ? new Date(dumyDeliveryDate)
        : new Date(
          _today.getMonth() +
          1 +
          "/" +
          _today.getDate() +
          "/" +
          _today.getFullYear()
        );

    const orignStartDate2 =
      dumyDeliveryDate && dumyDeliveryDate !== ""
        ? new Date(dumyDeliveryDate)
        : new Date(
          _today.getMonth() +
          1 +
          "/" +
          _today.getDate() +
          "/" +
          _today.getFullYear()
        );

    let checkVaildDate = startDate instanceof Date && !isNaN(startDate);

    if (checkVaildDate === false) {
      return deliveryList;
    }

    // const abc =
    //   orignStartDate2.getMonth() +
    //   1 +
    //   "/" +
    //   orignStartDate2.getDate() +
    //   "/" +
    //   orignStartDate2.getFullYear();

    // key dates
    const cutoffDate = new Date(2026, 4, 22); // May 22, 2026
    const eventEndDate = new Date(2026, 6, 11); // July 11, 2026

    // startDate.setDate(startDate.getDate() + 3);
    // orignStartDate.setDate(orignStartDate.getDate() + 3);

    //console.log("startDate", startDate);
    //console.log("_minDate", _minDate);
    //console.log("_today", new Date((_today.getMonth() + 1) + '/' + _today.getDate() + '/' + _today.getFullYear()));

    // check if the event ended
    if (currentDate > eventEndDate) {
      return [{ name: "Event Ended", value: "" }];
    }

    // check the start Date 
    if (currentDate <= cutoffDate) {
      return deliveryList;
    }

    let _deliveryList = [];

    _deliveryList.push({ name: "Select Date", value: "" });

    // Calculate the minimum date based on current time
    let minDeliveryDate = new Date(currentDate);

    // Sunday
    if (minDeliveryDate.getDay() === 0) {
      minDeliveryDate.setDate(minDeliveryDate.getDate() + 1);
    }

    // Adjust for time of day
    if (currentHour >= 15) {
      minDeliveryDate.setDate(minDeliveryDate.getDate() + 2); // After 15:00, skip next 2 days
    } else {
      minDeliveryDate.setDate(minDeliveryDate.getDate() + 1); // Before 15:00, skip next day
    }

    // Date range disable logic based on cutoff times
    const currentDateTime = new Date(_today.getFullYear(), _today.getMonth(), _today.getDate(), currentHour, _today.getMinutes());
    
    // Cutoff 1: After May 24, 2026 11:00 PM → disable May 26 - June 3, 2026
    const cutoff1 = new Date(2026, 4, 24, 23, 0);
    const disableStart1 = new Date(2026, 4, 26);
    const disableEnd1 = new Date(2026, 5, 3);
    
    // Cutoff 2: After June 28, 2026 11:00 PM → disable July 1 - July 3, 2026
    const cutoff2 = new Date(2026, 5, 28, 23, 0);
    const disableStart2 = new Date(2026, 6, 1);
    const disableEnd2 = new Date(2026, 6, 3);
    
    // Cutoff 3: After July 2, 2026 11:00 PM → disable July 6 - July 11, 2026
    const cutoff3 = new Date(2026, 6, 2, 23, 0);
    const disableStart3 = new Date(2026, 6, 6);
    const disableEnd3 = new Date(2026, 6, 11);

    // Helper function to check if a date should be disabled
    const isDateDisabled = (itemDate) => {
      // Check cutoff 1
      if (currentDateTime > cutoff1 && itemDate >= disableStart1 && itemDate <= disableEnd1) {
        return true;
      }
      // Check cutoff 2
      if (currentDateTime > cutoff2 && itemDate >= disableStart2 && itemDate <= disableEnd2) {
        return true;
      }
      // Check cutoff 3
      if (currentDateTime > cutoff3 && itemDate >= disableStart3 && itemDate <= disableEnd3) {
        return true;
      }
      return false;
    };

    // Filter dates based on requirements
    for (const item of deliveryList) {
      // After May 22, only show July dates
      if (currentDate > cutoffDate && item.date < new Date(2026, 6, 1)) {
        continue;
      }

      // Check if date should be disabled based on cutoff times
      if (item.date && isDateDisabled(item.date)) {
        continue;
      }

      // Only show dates after the calculated minimum date
      if (item.date >= minDeliveryDate) {
        _deliveryList.push({ name: item.name, value: item.value });
      }
    }

    // If no dates available (e.g., ordered too late on July 3rd)
    if (_deliveryList.length === 1) {
      return [{ name: "No available dates", value: "" }];
    }

    return _deliveryList;

    // let _convertDateToText = "";
    // let checkLoop = true;

    // while (checkLoop) {
    //   if (startDate.getDay() === 0) {
    //     startDate.setDate(startDate.getDate() + 1);
    //   }


    //   if (
    //     startDate <= _juneMaxDate ||
    //     (startDate >= _julyMinDate && startDate <= _maxDate)
    //   ) {
    //     if (orignStartDate2 > new Date("5/22/2025") && orignStartDate2 <= new Date("5/25/2025")) {
    //       if (startDate >= new Date("5/30/2025")) {
    //         _convertDateToText = convertDateToText(startDate);
    //         _deliveryList.push({
    //           name: _convertDateToText,
    //           value: _convertDateToText,
    //         });
    //       }
    //     }
    //     else if (orignStartDate2 >= new Date("5/22/2025")) {
    //       if (startDate >= new Date("7/3/2025")) {
    //         _convertDateToText = convertDateToText(startDate);
    //         _deliveryList.push({
    //           name: _convertDateToText,
    //           value: _convertDateToText,
    //         });
    //       }
    //     } else {
    //       _convertDateToText = convertDateToText(startDate);
    //       _deliveryList.push({
    //         name: _convertDateToText,
    //         value: _convertDateToText,
    //       });
    //     }
    //   }

    //   if (startDate >= _maxDate) {
    //     _deliveryList.push({
    //       name: "NAIDOC week ended",
    //       value: "",
    //     });
    //     checkLoop = false;
    //   }
    //   startDate.setDate(startDate.getDate() + 1);
    // }

    // if (_deliveryList.length === 1 && orignStartDate >= _lasMaxDate) {
    //   //0
    //   if (orignStartDate.getDay() === 0) {
    //     orignStartDate.setDate(orignStartDate.getDate() + 1);
    //   }
    //   _convertDateToText = convertDateToText(orignStartDate);
    //   _deliveryList.push({
    //     name: _convertDateToText,
    //     value: _convertDateToText,
    //   });
    // }

    // return _deliveryList;
  };

  const model = fb.group({
    billingAddress: address(data.billingAddress),
    shippingAddress: address(data.shippingAddress),
    //shippingMethod: [data.shippingMethod || '', [], { label: 'Shipping Method', type: 'text' }],
    shippingMethod: [
      data.shippingMethod || "",
      [],
      {
        label: null,
        type: "radioList",
        options: shippingMethods,
        style: { inline: true },
      },
    ],
    shippingCountry: [
      data.shippingCountry || "Australia",
      [],
      {
        label: null,
        type: "radioList",
        options: shippingCountry,
        style: { inline: true },
      },
    ],
    useSameAddress: [
      data.useSameAddress || false,
      [],
      { label: `Use the same address`, type: "checkbox" },
    ],
    //deliveryPickupDate: [data.deliveryPickupDate || '', [validators.Required()], { label: null, type: 'select', options: deliveryList }],
    deliveryPickupDate: [
      data.deliveryPickupDate || "",
      [validators.Required()],
      { label: null, type: "select", options: getDeliveryDate() },
    ],
    deliveryPickupTime: [
      data.deliveryPickupTime || "",
      [data.shippingMethod === "Standard" && validators.Required()],
      { label: null, type: "select", options: pickupTimeList },
    ],
    location: [
      data.location || "Cafe de Vili’s (Mile End)",
      [data.shippingMethod === "Pickup" && validators.Required()],
      { label: null, type: "select", options: locationList },
    ],
    deliveryInstructions: [
      data.deliveryInstructions || "",
      [],
      { label: null, type: "textarea" },
    ],
  });
  return model;
}

export function address(model) {
  const data = model || {};
  return fb.group({
    firstName: [
      data.firstName || "",
      [validators.Required()],
      { label: "First Name", type: "text" },
    ],
    surname: [
      data.surname || "",
      [validators.Required()],
      { label: "Surname", type: "text" },
    ],
    street1: [
      data.street1 || "",
      [validators.Required()],
      { label: "Street", type: "text" },
    ],
    street2: [data.street2 || "", [], { label: null, type: "text" }],
    suburb: [
      data.suburb || "",
      [validators.Required()],
      { label: "Suburb", type: "text" },
    ],
    state: [
      data.state || "",
      [validators.Required()],
      { label: "State", type: "text" },
    ],
    postcode: [
      data.postcode || "",
      [validators.Required()],
      { label: "Postcode", type: "text" },
    ],
    email: [
      data.email || "",
      [validators.Required(), validators.Email()],
      { label: "Email Address", type: "email" },
    ],
    mobile: [
      data.mobile || "",
      [validators.Required()],
      { label: "Mobile", type: "tel" },
    ],
    businessName: [
      data.businessName || "",
      [],
      { label: "Business Name", type: "text" },
    ],
    abn: [data.abn || "", [], { label: "ABN", type: "text" }],
  });
}
